export const variables = {
    welcomeTimer: 1000,
    greetings: ['Hello', 'Hola', 'Bonjour', 'Hallo', '你好', 'こんにちは', '안녕하세요', 'Привет', 'مرحبا', 'Ciao', 'नमस्ते']
}